<!-- 订阅信息设置 -->
<template>
    <div class='page_content'>
        <div class="page_content_top">
            <v-button :buttonList="[]"  @getPageInfo="getPageInfo" :showRefresh="true" :buttonFlag="false"></v-button>
         <div class="page_content_top_line">
            <el-form :inline="true" :model="requestData" class="demo-form-inline" size="mini" label-width="100px">
               <el-form-item label="任务名称">
                <label slot="label" :style="$common.labelStyle('任务名称')" v-html="'任务名称'"></label>
                  <el-input class="form_codition" v-model.trim="requestData.taskName" clearable size="mini" placeholder="请输入任务名称" ></el-input>
               </el-form-item>
               <el-form-item>
                  <el-button type="primary" size="mini" @click="getProcessList">查询</el-button>
               </el-form-item>
            </el-form>
         </div>
      </div>
    <el-card class="box-card">
        <div class='page_content'>
            <div class="page_content_center">
                <el-tabs v-model="showTabs" :stretch="false" :closable="true"
                    class="el-tabs--border-card_new" type="card">
                    <el-tab-pane label="订阅信息" name="ho">
                        <div style="height: 670px;">
                            <el-table size="mini" id="mxTable" :data="processList" height="100%" border
                                style="height:100%;width: 800px;margin-top:10px" highlight-current-row>
                                <el-table-column prop="receiverName" label="接收人" show-overflow-tooltip></el-table-column>
                                <el-table-column prop="taskName" label="任务功能" show-overflow-tooltip></el-table-column>
                                <el-table-column prop="functionId" label="任务功能ID" show-overflow-tooltip></el-table-column>
                                <el-table-column label="操作" width="102">
                                    <template slot-scope="scope">
                                        <el-button type="primary" size="mini" @click="openPer(scope.row)">编辑
                                        </el-button>
                                    </template>
                                </el-table-column>
                            </el-table>
                        </div>
                    </el-tab-pane>
                </el-tabs>
            </div>
            <el-dialog title="人员列表" v-if="perDia" :visible.sync="perDia">
                <el-table :data="perList" ref="perList" border @selection-change="handleSelectionChange" height="450px"
                    size="mini" v-loading="loading">
                    <el-table-column type="selection" width="40"></el-table-column>
                    <el-table-column property="opmName" label="人员" show-overflow-tooltip></el-table-column>
                    <el-table-column property="depName" label="部门" show-overflow-tooltip></el-table-column>
                </el-table>
                <div slot="footer" class="dialog-footer">
                    <el-button @click="perDia = false">取 消</el-button>
                    <el-button type="primary" @click="selPerson">确 定</el-button>
                </div>
            </el-dialog>
        </div>
    </el-card>
</div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
// import {mock} from "@/api/formList.js"
export default {
    //import引入的组件需要注入到对象中才能使用
    components: {},
    data() {
        //这里存放数据
        return {
            requestData: {
                "functionId": "",
                "receiver": "",
                "receiverName": "",
                "tareId": '',
                "taskName": ""
            },
            processList: [],
            showTabs: 'ho',
            perList: [],
            multipleSelection: [],
            perDia: false,
            loading: false,
            selOpm: [],
            tareId: ''
        };
    },
    //监听属性 类似于data概念
    computed: {},
    //监控data中的数据变化
    watch: {},
    //方法集合
    methods: {
        async selPerson() {
            console.log(this.multipleSelection)
            let personArr = []
            this.multipleSelection.forEach(item => {
                personArr.push(item.opmId)
            })
            let params = {
                tareId: this.tareId,
                receiver: personArr.toString()
            }
            let responseData = await this.$http.updateTaskreceiver(params)
            if (responseData && responseData.status == 200) {
                this.$message({
                    message: responseData.message,
                    type: 'success'
                });
                this.getProcessList()
                this.perDia = false
            } else {
                this.$message({
                    message: responseData.message,
                    type: 'error'
                });
            }
            this.$forceUpdate()
        },
        // 打开人员选择框
        openPer(row) {
            this.perDia = true
            this.tareId = row.tareId
            this.selOpm = row.receiver.split(',')
            this.queryOperator()
        },
        handleSelectionChange(val) {
            this.multipleSelection = val;
        },
        //查询流程列表
        async getProcessList() {
            let responseData = await this.$http.queryTaskreceiver(this.requestData)
            if (responseData && responseData.status == 200) {
                this.processList = responseData.result
            } else {
                this.$message({
                    message: responseData.message,
                    type: 'error'
                });
            }
        },

        //查询人员列表
        async queryOperator() {
            this.loading = true
            let params = {
                page: 1,
                rows: 1000
            }
            let responseData = await this.$http.queryOperator(params)
            if (responseData && responseData.status == 200) {
                this.perList = []
                responseData.result.list.forEach(item => {
                    this.perList.push(
                        {
                            opmName: item.opmName,
                            opmId: item.opmId,
                            depName: item.depName,
                        }
                    )
                })
                this.loading = false
                this.$nextTick(() => {
                    this.$nextTick(() => {
                        this.perList.forEach((item, index) => {
                            this.selOpm.forEach((keys, i) => {
                                if (item.opmId == keys) {
                                    this.$refs.perList.toggleRowSelection(this.perList[index])
                                }
                            })
                        })
                    })
                    this.loading = false
                })
            } else {
                this.$message({
                    message: responseData.message,
                    type: 'error'
                });
            }
        },
          // 获取数据列表
			async getPageInfo() {
				var pathId = parent.getMenuInfo(this.$route.path);
				let responseData = await this.$http.getJur({
					ids: [pathId.jurId],
				});
				if (responseData.status == 200) {
					this.pageShowData = responseData.result;
					this.formDataList = this.pageShowData.jurFormVoList
					this.getProcessList();
					// this.getButtonList();
				} else {
					this.$message({
						message: responseData.message,
						type: "error",
					});
				}
			},
    },
    //生命周期 - 创建完成（可以访问当前this实例）
    created() {
        this.getProcessList()

    },
    //生命周期 - 挂载完成（可以访问DOM元素）
    mounted() { },
    beforeCreate() { }, //生命周期 - 创建之前
    beforeMount() { }, //生命周期 - 挂载之前
    beforeUpdate() { }, //生命周期 - 更新之前
    updated() { }, //生命周期 - 更新之后
    beforeDestroy() { }, //生命周期 - 销毁之前
    destroyed() { }, //生命周期 - 销毁完成
    activated() { }, //如果页面有keep-alive缓存功能，这个函数会触发
}
</script>

<style scoped>
.el-card {
    min-height: 90vh;
    margin: 20px;
}

.el-tabs-box {
    margin-top: 20px;
}

.el-tabs__content {
    height: 90% !important;
    min-height: 70vh;
}

/* .page_content_top_line {
    margin-top: 20px;
} */

.draw {
    padding: 20px;
}

.el-select {
    width: 100%;
}

.block {
    margin-top: 20px;
}

::v-deep .el-tabs__nav .el-tabs__item:nth-child(1) span {
    display: none;
}

.flowBox {
    width: 250px;
    position: relative;

}

.flowCon {
    width: 100%;
    border-radius: 10px;
    background: #efefef;
    /* box-shadow: 0 2px 12px 0 rgb(0 0 0 / 10%); */
}

.flowtt {
    width: 100%;
    height: 35px;
    color: #fff;
    border-top-right-radius: 10px;
    border-top-left-radius: 10px;
    line-height: 35px;
    padding-left: 10px;
    background: rgb(45, 97, 240);
}

.flowUser {
    height: 70px;
    padding: 10px;
    font-size: 14px;
    overflow-y: auto;
}

.clo {
    position: absolute;
    top: 8px;
    right: 8px;
    z-index: 999;
    color: #fff;
    font-size: 21px;
}

.flowimg {
    width: 100%;
    text-align: center;
}

.add {
    position: absolute;
    right: 52px;
    bottom: 18px;
    width: 30px;
}

input {
    outline: none;
    border: none;
}

.mainInfo {
    display: flex;
    justify-content: space-between;
}

.oneInfo {
    width: 48%;
    height: 72vh;
    overflow-y: auto;
}

.line {
    width: 2px;
    height: 70vh;
    border-right: 2px dashed #999;
}

.mainBox {
    display: flex;
    justify-content: center;
}

::v-deep .el-dialog__body {
    padding: 6px 20px;
}

.btn {
    width: 100%;
    display: flex;
    justify-content: center;
}

.btn button {
    width: 200px;
    margin-top: 10px;
}
</style>
